import { html, LitElement } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin";

import { store } from "@stofloos/stores/store";
import { initRequest } from "@stofloos/actions/requests";
import { readObject } from "@stofloos/actions/crud";
import { localize } from "@stofloos/actions/localize";
import { StofwareLinks } from "@stofloos/globals/styles/links";

String.prototype.interpolate = function(params) {
	if (!params) {
		return this;
	}
	const names = Object.keys(params);
	const vals = Object.values(params);
	return new Function(...names, `return \`${this}\`;`)(...vals);
};

String.prototype.translateSentence = function() {
	const words = this.split(" ");
	const translations = words.map(function(word) {
		return localize(word);
	});
	return translations.join(" ");
};

class StofwareContentBlock extends connect(store)(LitElement) {
	static get styles() {
		return [StofwareLinks];
	}

	render() {
		return html`
			<style>
				:host {
					width: 100%;
				}

				hr {
					border: 1px solid var(--app-lightgrey);
				}

				table {
					width: 100%;
					table-layout: fixed;
				}

				table img {
					max-width: 100%;
				}

				img {
					max-width: 100%;
					border-radius: var(--sw-content-block-img-border-radius);
				}

				#content-block-template a,
				#content-block-template a:visited {
					color: var(--sw-content-block-link-color);
				}

				blockquote:before {
					color: var(--app-lightgrey-color);
					content: open-quote;
					font-size: 4em;
					line-height: 0.1em;
					margin-right: 0.25em;
					vertical-align: -0.4em;
				}
			</style>
			<div id="content-block-template">
				${this.contentBlock}
			</div>
		`;
	}

	static get properties() {
		return {
			contentId: { type: Number },
			template: { type: Object },
			contentBlock: { type: Object },
			isLoading: { type: Boolean },
			data: { type: Object }
		};
	}

	constructor() {
		super();
	}

	shouldMakeRequest(state) {
		const name = "contentBlock" + this.contentId;
		if (
			this.contentId &&
			typeof state.crud[name] === "undefined" &&
			typeof state.requests[name] === "undefined" &&
			!this.isLoading
		) {
			this.isLoading = true;
			store.dispatch(initRequest(name, "contentblock"));
			store.dispatch(readObject(name, this.contentId, true)).then(response => {
				this.template = response;
				this.fillTemplate(this.template, this.data);
				this.isLoading = false;
			});
		} else if (typeof state.crud[name] !== "undefined" && typeof this.template === "undefined") {
			this.template = state.crud[name];
			this.fillTemplate(this.template, this.data);
		}
	}

	stateChanged(state) {
		this.shouldMakeRequest(state);
	}

	updated(changedProps) {
		if (changedProps.has("data")) {
			this.getTemplate();
		}
		if (changedProps.has("contentBlock")) {
			this.shadowRoot.getElementById("content-block-template").innerHTML = this.contentBlock;
		}
	}

	getTemplate() {
		store.dispatch(initRequest("contentBlock", "contentblock"));
		store.dispatch(readObject("contentBlock", this.contentId)).then(response => {
			this.template = response;
			this.fillTemplate(this.template, this.data);
		});
	}

	fillTemplate(template, data) {
		if (!template) {
			return;
		}
		let filledTemplate = template.body.interpolate(data);
		this.contentBlock = filledTemplate;
	}
}

window.customElements.define("sw-content-block", StofwareContentBlock);
